storefrontApp.service('elasticService', ['$http', 'configs', function ($http, configs) {
    return {
        //#region Helper Functions
        getElasticData: function (request, baseUrl) {
            if (window.__env && window.__env.elasticBaseUrl) {
                configs = window.__env;
            } else {
                console.log("ES not Available. Switching to Defaults");
            }
            return $http({
                method: 'POST',
                url: baseUrl ? baseUrl : configs.elasticBaseUrl,
                data: request,
                headers: {
                    'Authorization': 'Basic ' + btoa('elasticReadOnly:' + configs.elasticKey),
                }
            }).then(function (response) {
                return response;
            });
        },
        getKeywordsElasticData: function (request, baseUrl) {
            if (window.__env && window.__env.elasticKeywordsBaseUrl) {
                configs = window.__env;
            } else {
                console.log("ES not Available. Switching to Defaults");
            }
            return $http({
                method: 'POST',
                url: baseUrl ? baseUrl : configs.elasticKeywordsBaseUrl,
                data: request,
                headers: {
                    'Authorization': 'Basic ' + btoa('elasticReadOnly:' + configs.elasticKey),
                }
            }).then(function (response) {
                return response;
            });
        },
        getOrdersLineItemElasticData: function (request, baseUrl) {
            if (window.__env && window.__env.elasticOrdersBaseUrl) {
                configs = window.__env;
            } else {
                console.log("ES not Available. Switching to Defaults");
            }
            return $http({
                method: 'POST',
                url: baseUrl ? baseUrl : configs.elasticOrdersBaseUrl,
                data: request,
                headers: {
                    'Authorization': 'Basic ' + btoa('elasticReadOnly:' + configs.elasticKey),
                }
            }).then(function (response) {
                return response;
            });
        },
        //#endregion

        //#region Homepage Elastic Queries
        buildNewArrivalsRequest: function (prdDefs, size) {
                size = size || 100;
                if (angular.isDefined(prdDefs) && prdDefs.length > 0) {
                    var prdDefObj = [];
                    prdDefs.map(function (def) {
                        prdDefObj.push({
                            "term": {
                                "definitionName": def
                            }
                        })
                    });
    
                    return (
                        '{"query":{"bool":{"must":[{"range":{"listPrice":{"gt":0}}},{"bool":' +
                        '{"should":' + JSON.stringify(prdDefObj) + '}}]}},"size":0,' +
                        '"aggs":{"definitions":{"terms":{"field":"definitionName"},"aggs":{"topByDefinitions":' +
                        '{"top_hits":{"sort":[{"yearCreated":{"order":"desc"}}],"size":' + size + ',"_source":{"includes":' +
                        '["brand", "catalog", "name", "listPrice", "salePrice", "clubPrice", "itemId", "variants.variantId", "variants.numberOfDesigns", "isBuyable", "definitionName", "rating", "saleRank"]}}}}}}}'
                    );
                }
                return null;
          
        },
        //#endregion

        //#region Filter by Category List Keyword
        buildCategoryListKeywordRequest: function (definitionName, keyword, noiseKeyword) {
            return (
                '{"query":{"bool":{"must":[' +
                ((definitionName && definitionName.length > 0) ? '{"term":{"definitionName":{"value":"' + definitionName + '"}}},' : '') +
                '{"term":{"categoriesList.keyword":{"value":"' + keyword + '"}}}]' + (noiseKeyword && noiseKeyword.length > 0 ? ',"must_not":[{"term":{"categoriesList.keyword":{"value":"' + noiseKeyword + '"}}}]' : '') +
                '}},"size":0,"aggs":{"items":{"top_hits":{"size":50,"sort":[{"yearCreated": "desc"},{"saleRank": "desc"},{"rating": "desc"}],"_source":{"includes":["brand","catalog","name","listPrice","salePrice","itemId","variants.variantId","isBuyable","definitionName","rating","saleRank"]}}}}}'
            );
        },
        //#endregion

        //#region Top Picks
        buildTopPicksRequest: function () {
                return (
                    req = '{"track_total_hits": true, "query": { "bool": { "must": [ { "term": { "definitionName": { "value": "StockDesign" } } }, { "range": { "listPrice": { "gt": 0 } } } ] } },' +
                    ' "size": 0, "aggs": { "top_picks": { "terms": { "field": "definitionName" },' +
                    ' "aggs": { "top_picks": { "top_hits": { "sort": [ { "yearCreated": { "order": "desc" } } ], "size": 100, "_source": { "includes": [ "brand", "catalog", "name", "listPrice", "salePrice", "itemId", "variants.variantId", "isBuyable", "definitionName" ] } } } } } } }'
                );
        },

        buildDefaultTopPicksRequest: function () {
                return (
                    req = '{"track_total_hits": true, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                    '{ "bool": { "should": [ { "term": { "definitionName": "StockDesign" } }, { "term": { "definitionName": "Font" } }, { "term": { "definitionName": "DesignPack" } } ] } } ] } },' +
                    '"size": 0, "aggs": { "definitions": { "terms": { "field": "definitionName" }, "aggs": { "topByDefinitions": { "top_hits": { "sort": [ { "saleRank": { "order": "desc" } } ], "size": 25,' +
                    '"_source": { "includes": [ "brand", "catalog", "name", "listPrice", "salePrice", "itemId", "variants.variantId", "isBuyable", "definitionName" ] } } } } } } }'
                );
           
        },

        buildDefaultStockDesignsRequest: function () {
                return (
                    req = '{"track_total_hits": true, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                    '{ "bool": { "should": [ { "term": { "definitionName": "StockDesign" } } ] } } ] } },' +
                    '"size": 0, "aggs": { "definitions": { "terms": { "field": "definitionName" }, "aggs": { "topByDefinitions": { "top_hits": { "sort": [ { "saleRank": { "order": "desc" } } ], "size": 100,' +
                    '"_source": { "includes": [ "brand", "catalog", "name", "listPrice", "salePrice", "itemId", "variants.variantId", "isBuyable", "definitionName" ] } } } } } } }'
                );
        },

        buildDefaultOtherProductsRequest: function () {
            var definitionTerms = [];
                    angular.forEach(
                        ["Font", "DesignPack"],
                        function (def) {
                            definitionTerms.push({
                                term: { "definitionName": def }
                            });
                        });
                    var request = '{"track_total_hits": true, "_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable"]}, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                        '{ "bool": { "should":' + angular.toJson(definitionTerms) + '} } ] } }, "size": 25 ,"sort":[{"saleRank":{"order":"desc"}}] } ';
                    return request;
           
        },

        buildPDFPatternsProductsRequest: function () {
            var patternTerms = [];
                    angular.forEach(
                        ["Sewing PDF Patterns", "Clothing PDF Patterns", "Crochet PDF Patterns", "Quilting PDF Patterns", "Cross Stitch PDF Patterns", "Knitting PDF Patterns", "Hand Embroidery", "Foundation Paper Piecing PDF Patterns"],
                        function (def) {
                            patternTerms.push({
                                term: { "definitionName": def }
                            });
                        });
                    var request = '{"track_total_hits": true, "_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable"]}, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                        '{ "bool": { "should":' + angular.toJson(patternTerms) + '} } ] } }, "size": 25 ,"sort":[{"saleRank":{"order":"desc"}}] }';
                    return request;
          
        },

        buildShippableProductsRequest: function () {
            var shippingTerms = [];
                angular.forEach(
                    ["Supplies", "Equipment", "Embroiderable", "Quilting", "Thread", "CDPackage", "Education", "Collection", "Software"],
                    function (def) {
                        shippingTerms.push({
                            term: { "definitionName": def }
                        });
                    });
                var request = '{"track_total_hits": true, "_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable"]}, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                    '{ "bool": { "should":' + angular.toJson(shippingTerms) + '} } ] } }, "size": 25 ,"sort":[{"saleRank":{"order":"desc"}}] }';
                return request;
        },

        buildRecentlyViewedFillers: function(prdDefs,sizeReq){
            var prdDefObj = [];
                if (angular.isDefined(prdDefs) && prdDefs.length > 0) {
                    prdDefs.map(function (def) {
                        prdDefObj.push({
                            "term": {
                                "definitionName": def
                            }
                        })
                    });
                }
                var request = '{"track_total_hits": true, "_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable"]}, "query": { "bool": { "must": [ { "range": { "listPrice": { "gt": 0 } } },' +
                    '{ "bool": { "should":' + angular.toJson(prdDefObj) + '} } ] } }, "size": '+ sizeReq +' ,"sort":[{"saleRank":{"order":"desc"}}] }';
                return request;
        
        },

        buildProductByIdsRequest: function (searchTerm) {
            return (
                req = '{"track_total_hits": true, "query":{"ids":{"values":' + searchTerm + '}}}'
            );
        },
        //#endregion

        //#region Associated Packs
        buildAssociatedPacksRequest: function (productId) {
            return (
                req = '{ "query": { "wildcard": { "variants.associatedItemsList": { "value": "' + productId.toLowerCase() + '" } } } }'
            );
        },
        //#endregion

        //#region AssociatedItems
        buildAssociatedItemsRequest: function (associatedItems) {
            return (
                req = '{ "query": { "terms": { "_id":' + angular.toJson(associatedItems) + ' } }, "size": ' + associatedItems.length + ' }'
            );
        },

        //#region Product Info
        buildProductInfoRequest: function (productId, hasExcludes, hasIncludes, hasMultiple) {
            if (angular.isDefined(productId)) {
                var req = {};
                if(hasMultiple){
                    req = {
                        _source: {
                            "excludes": [],
                            "includes": []
                        },
                        query:
                        {
                            "terms": {
                                _id: []
                            }
                        }
                    }
                    productId.map(function(m){
                        req.query.terms._id.push(m.toLowerCase())
                    });
                }
                else{
                    if(Array.isArray(productId)){
                        productId = productId[0];
                    }
                    req = {
                        _source: {
                            "excludes": [],
                            "includes": []
                        },
                        "query":
                        {
                            "terms": { "_id": [ productId ] }
                        }
                    }
                }
                if (hasExcludes && Array.isArray(hasExcludes)) {
                    hasExcludes.map(function(m){
                        req._source.excludes.push(m)
                    });
                }
                if (hasIncludes && Array.isArray(hasIncludes)) {
                    hasIncludes.map(function(m){
                        req._source.includes.push(m)
                    });
                }
                return(
                    req = (
                        JSON.stringify(req)
                    )
                );
            }
            else {
                return (null);
            }
        },

        buildVariantTabContentRequest:function(productId,variantId){
            if(angular.isDefined(productId) && angular.isDefined(variantId))
                {
                    return(
                        req = '{"_source":false,"query":{"bool":{"must":[{"terms":{"_id":["'+ productId +'"]}}]}},"script_fields": { "filtered_variants": {"script": {"source": "def variants = params[\'_source\'][\'variants\'];for (variant in variants) {if (variant[\'variantId\'] == params[\'variantId\']) {return variant;}}","params": {"variantId": '+ variantId +'}}}}}'
                    );
                }
            else {
                return null;
            }
        },
        buildOrderIdsQuery: function(productId) {
            if (angular.isDefined(productId)) {
                return JSON.stringify({
                    size: 0, // no actual hits, only aggregation
                    query: {
                        match: {
                            "productId.keyword": productId
                        }
                    },
                    aggs: {
                        distinct_orderIds: {
                            terms: {
                                field: "orderId.keyword",
                                size: 10000 // adjust as needed
                            }
                        }
                    }
                });
            } else {
                return null;
            }
        },
        
        buildRelatedProductsQuery: function(orderIds, vendorIds, excludeProductId) {
            return JSON.stringify({
                size: 0,
                query: {
                    bool: {
                        must: [
                            { terms: { "orderId.keyword": orderIds } },
                            { terms: { "catalogId.keyword": vendorIds } },
                            { terms: { "productDefinition.keyword": ["Font", "StockDesign","PrintArt","SVG"] } }
                        ],
                        must_not: [
                            { match: { "productId.keyword": excludeProductId } }
                        ]
                    }
                },
                aggs: {
                    frequently_bought_together: {
                        terms: {
                            field: "productId.keyword",
                            size: 2,
                            order: { "_count": "desc" }
                        }
                    }
                }
            });
        },
        //#endregion

        //#region Favorites
        buildFavoriteItemsInfoRequest: function (itemIds, size) {
            return (
                req = '{"track_total_hits": true, "query":{"ids":{"values":["' + itemIds + '"]}},"size":0,"aggs":{"favorites":{"top_hits":{"size":' + size + ',"_source":{"includes":["brand","catalog","name","listPrice","salePrice","variants.listPrice","variants.salePrice","variants.width_in","variants.height_in","variants.variantId","variants.manufacturerPartNumber", "variants.itemId" , "variants.rGB", "variants.variantLabel", "itemId","isBuyable","definitionName","productId", "saleEndDate"]}}}}}'
            )
        },
        buildBrandSampleInfoRequest: function (brands, size,free) {
                if(!free){
                    return (
                    req = '{"track_total_hits": true, "query": {"bool": {"must": [{"range": {"listPrice": {"gt": 0}}},{"terms": {"brand.raw": ["' + brands + '"]}}]}},'
                    + '"size": 0,"aggs": {"groupbyBrands": {"terms": {"size": ' + size + ' , "field": "brand.raw"},"aggs": {"groupbyBrands": {"top_hits": {"size": 10,"_source": {"includes": ["brand","catalog","name","itemId","definitionName"]}}}}}}}'
                    )
                }
                else{
                     return (
                    req = '{"track_total_hits": true, "query": {"bool": {"must": [{"term": {"listPrice":0}},{"terms": {"brand.raw": ["' + brands + '"]}}]}},'
                    + '"size": 0,"aggs": {"groupbyBrands": {"terms": {"size": ' + size + ' , "field": "brand.raw"},"aggs": {"groupbyBrands": {"top_hits": {"size": 10,"_source": {"includes": ["brand","catalog","name","itemId","definitionName"]}}}}}}}'
                    )
                }
          
        },
        buildBrandDefinitionsInfoRequest: function (brands, size,free) {

                    if(!free){
                        return (
                            req = '{"track_total_hits": true, "query": {"bool": {"must": [{"terms": {"brand.raw": ["' + brands + '"]}}], "must_not": [{"terms": {"definitionName": [ "SVG" ]}}]}},"aggs": {"groupbyBrands": {"terms": '
                            + '{"field": "brand.raw","size": ' + size + '},"aggs": {"groupbyDef": {"terms": {"field": "definitionName","size": 3}}}}},"size": 0}'
                        )
                    }
                    else{
                        return (
                        req = '{"track_total_hits": true, "query": {"bool": {"must": [{"terms": {"brand.raw": ["' + brands + '"]}},{"term": {"listPrice":0}}], "must_not": [{"terms": {"definitionName": [ "SVG","Font","DesignPack" ]}}]}},"aggs": {"groupbyBrands": {"terms": '
                        + '{"field": "brand.raw","size": ' + size + '},"aggs": {"groupbyDef": {"terms": {"field": "definitionName","size": 3}}}}},"size": 0}'
                        )
                    }
               
            
        },
        buildMoreItemsFromBrandRequest: function(brand, definition, prdId, isPatch){
                if(["SVG","PrintArt"].indexOf(definition) > -1){
                    return (
                        '{"from":0,"size":60,"_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable"]},"query":{"bool":{"must":[{"term":{"brand":"'+ brand +'"}},{"range": {"listPrice":{"gt":0}}}],"must_not": [{"term": {"_id": {"value": "'+ prdId +'"}}}]}},"sort":[{"_script": {"type": "number","script": {"lang": "painless","source": "Math.random()"},"order": "asc"}},{"saleRank":{"order":"desc"}}]}'
                    );
                }
                else if(isPatch){
                    return (
                        '{"from":0,"size":60,"_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable"]},"query":{"bool":{"must":[{"term":{"brand":"'+ brand +'"}},{"range":{"listPrice": {"gt": 0}}},{"term":{"variants.isPatchEligible": true}}],"must_not":[{"terms":{"definitionName":["SVG","PrintArt"]}},{"term": {"_id": {"value": "'+ prdId +'"}}}]}},"sort":[{"_script": {"type": "number","script": {"lang": "painless","source": "Math.random()"},"order": "asc"}},{"saleRank":{"order":"desc"}}]}'
                    );
                }
                else{
                    return (
                        '{"from":0,"size":60,"_source":{"excludes":["*.productTabContent","*.mainFeatures","variants.associatedItemsList","variants.associatedItems","categories","categoriesList","variants.fTA","designKeywords","keywords","colorSequence","variants.fileTypesAvailable"]},"query":{"bool":{"must":[{"term":{"brand":"'+ brand +'"}},{"range":{"listPrice": {"gt": 0}}}],"must_not":[{"terms":{"definitionName":["SVG","PrintArt"]}},{"term": {"_id": {"value": "'+ prdId +'"}}}], "filter": [{"term": {"inStock": true}}]}},"sort":[{"_script": {"type": "number","script": {"lang": "painless","source": "Math.random()"},"order": "asc"}},{"saleRank":{"order":"desc"}}]}'
                    );
                }
            
        },
        //#endregion

        //#region Search
        buildSuggestedProductsRequest: function (searchTerm, definitionName) {
            if (definitionName.toLowerCase() == "all") {
                return (
                    req = '{"track_total_hits": true, "sort":[{"saleRank":"desc"},{"rating":"desc"}],"query":{"bool":{'
                    + '"must":{"multi_match":{"query":"' + searchTerm + '","operator":"and","fields":["name","designKeywords","itemId", "productId"]}},'
                    + '"filter":{"bool":{"must":[{"range":{"listPrice":{"gt":0}}}]}}}},"from":0,"size":4}'
                );
            }
            else {
                return (
                    req = '{"track_total_hits": true, "sort":[{"saleRank":"desc"},{"rating":"desc"}],"query":{"bool":{'
                    + '"must":{"multi_match":{"query":"' + searchTerm + '","operator":"and","fields":["name","designKeywords","itemId", "productId"]}},'
                    + '"filter":{"bool":{"must":[{"range":{"listPrice":{"gt":0}}},{"term":{"definitionName":"' + definitionName + '"}}]}}}},"from":0,"size":4}'
                );
            }
        },

        buildSuggestedTermsRequest: function (searchTerm) {
            return (
                req = '{"suggest":{"keywordSuggest":{"text":"' + searchTerm + '","completion":{"field":' +
                '"keywordSuggest","fuzzy":{"fuzziness":1,"prefix_length":3}}}},"size": 0,"sort":[{"rank":{"order":"desc"}}]}'
            );
        },

        buildSuggestedCategoriesRequest: function (searchTerm) {
            return (
                req = '{"track_total_hits": true, "query":{"bool":{"must":[{"range":{"listPrice":{"gte":0.1}}}]}},"size": 0,"aggs":{"categoryList":' +
                '{"terms":{"field":"categoriesList.keyword","include":".*' + searchTerm + '.*","order":{"_count":"desc"},"size":3}}}}'
            );
        },

        buildSuggestedBrandsRequest: function (searchTerm) {
                return (
                    req = '{"track_total_hits": true, "query":{"bool":{"must":[{"wildcard":{"brand":{"value":"*' + searchTerm + '*"}}},' +
                    '{"range":{"listPrice":{"gt":0}}}]}},"aggs":{"brandlist":{"terms":{"field":"brand.raw","size":3}}},"size":0}'
                );
           
        },

        //#endregion
        //#region Product Code
        buildProductByProductCode: function (productCode, catalog) {
            if(angular.isUndefined(catalog)){
                return (
                    req = '{ "query": { "bool": { "must": [ { "term":{ "productId":{ "value":"' + productCode + '"} } } ] } } }'
                );
            }
            else{
                return (
                    req = '{ "query": { "bool": { "must": [ { "term":{ "productId":{ "value":"' + productCode + '"} } }, { "term":{ "catalog": { "value":"' + catalog + '"} } } ] } } }'
                );
            }
        },
        //#endregion

        //#region Brand listings
        buildBrands: function (definition,free) {
                if(definition.toLowerCase() == 'all')
                    {
                        return (
                            req = '{"track_total_hits": true,"size":0,"query":{"bool":{"must":[{"range":{"listPrice":{"gt":0}}}],"must_not":[{"term":{"brand.raw":{"value":"Contributor"}}}]}},"aggs":{"brands":{"terms":{"field":"brand.raw","order":{"_key":"asc"},"size":999}}}}'
                        )
        
                    }
                    else if(!free){
                        return (
                            req = '{"track_total_hits": true,"size":0,"query":{"bool":{"must":[{"term":{"definitionName":"' + definition + '"}},{"range":{"listPrice":{"gt":0}}}],"must_not":[{"term":{"brand.raw":{"value":"Contributor"}}}]}},"aggs":{"brands":{"terms":{"field":"brand.raw","order":{"_key":"asc"},"size":999}}}}'
                        )
                    }
                    else{
                        return (
                            req = '{"track_total_hits": true,"size":0,"query":{"bool":{"must":[{"term":{"definitionName":"' + definition + '"}},{"term":{"listPrice":0}}],"must_not":[{"term":{"brand.raw":{"value":"Contributor"}}}]}},"aggs":{"brands":{"terms":{"field":"brand.raw","order":{"_key":"asc"},"size":999}}}}'
                        )
                    }
        },
        //#endregion
        buildClubPricesTotalRequest:function (productIds) {
            return (
                req = '{"query":{"ids":{"values":["' + productIds + '"]}},"size":0,"aggs":{"items":{"top_hits":{"size":150,"_source":{"includes":["clubPrice","listPrice","salePrice","variants.variantId", "variants.listPrice", "variants.salePrice", "variants.clubPrice"]}}}}}'
            )
        }


    }
}]);
